<template>
    <div class="rounded-[4px] w-[26px] h-[26px] font-dm-sans-500 font-medium text-[14px] flex items-center justify-center cursor-pointer hover:bg-orange hover:text-white"
    :class="selected ? 'bg-orange text-white' : 'bg-white-gray text-gray-dark'">
        <slot />
    </div>
</template>

<script lang="ts" setup>
defineProps<{
    selected?: boolean
}>();
</script>
